import React from 'react';
import { Route } from 'react-router-dom';
import LayersListWrapper from '@features/map-layers-list/layers-list/LayersListWrapper';
import LayersTimeSelectors from '@features/map-layers-list/time-selector/LayersTimeSelectors';
import BreadcrumbedComponent from '@components/BreadcrumbedComponent/BreadcrumbedComponent';
import PopulationEventsList from '@features/scenario-presets-editor/PopulationEventsList';
import PopulationEventEdit from '@features/scenario-presets-editor/PopulationEventEdit';
import NetworkEventsList from '@features/scenario-presets-editor/NetworkEventsList';
import TransitEventsList from '@features/scenario-presets-editor/TransitEventsList';
import NetworkEventEdit from '@features/scenario-presets-editor/NetworkEventEdit';
import TransitEventEdit from '@features/scenario-presets-editor/TransitEventEdit';
import LazyLoadingWrapper from '@components/LazyLoadingWrapper/LazyLoadingWrapper';
import EvEventsList from '@features/scenario-presets-editor/EvEventsList';
import EvEventEdit from '@features/scenario-presets-editor/EvEventEdit';
import NavigateWithSearch from '@components/NavigateWithSearch/NavigateWithSearch';
import EmissionsEventsList from '@features/scenario-presets-editor/EmissionEventsList';
import EmissionEventEdit from '@features/scenario-presets-editor/EmissionEventEdit';

const ScenarioPresetsModePage = React.lazy(
    () => import('@pages/ProjectModes/ScenarioPresetsModePage')
);

export const useScenarioPresetsRoutes = () => {
    return (
        <Route
            path="scenario"
            element={<LazyLoadingWrapper element={<ScenarioPresetsModePage />} />}
        >
            <Route index element={<NavigateWithSearch to="population" replace />} />
            <Route
                element={<BreadcrumbedComponent />}
                handle={{
                    crumb: (data: any) => ({
                        pathnamePostFix: 'population',
                        name: 'Events',
                        ...data,
                    }),
                }}
            >
                <Route path="population">
                    <Route index element={<PopulationEventsList />} />
                    <Route path="new" element={<PopulationEventEdit />} />
                    <Route
                        path=":populationEventId/edit"
                        element={<PopulationEventEdit />}
                        loader={({ params }) => params}
                        handle={{ crumb: ({ populationEventId }) => ({ id: populationEventId }) }}
                    />
                </Route>
            </Route>
            <Route
                element={<BreadcrumbedComponent />}
                handle={{
                    crumb: (data: any) => ({ pathnamePostFix: 'network', name: 'Events', ...data }),
                }}
            >
                <Route path="network" element={<NetworkEventsList />} />
                <Route
                    path="network/new"
                    element={<NetworkEventEdit />}
                    loader={({ params }) => params}
                    handle={{ crumb: ({ networkEventId }) => ({ id: networkEventId }) }}
                />
                <Route
                    path="network/:networkEventId/edit"
                    element={<NetworkEventEdit />}
                    loader={({ params }) => params}
                    handle={{ crumb: ({ networkEventId }) => ({ id: networkEventId }) }}
                />
            </Route>
            <Route
                element={<BreadcrumbedComponent />}
                handle={{
                    crumb: (data: any) => ({ pathnamePostFix: 'transit', name: 'Events', ...data }),
                }}
            >
                <Route path="transit" element={<TransitEventsList />} />
                <Route
                    path="transit/new"
                    element={<TransitEventEdit />}
                    loader={({ params }) => params}
                    handle={{ crumb: ({ networkEventId }) => ({ id: networkEventId }) }}
                />
                <Route
                    path="transit/:transitEventId/edit"
                    element={<TransitEventEdit />}
                    loader={({ params }) => params}
                    handle={{ crumb: ({ transitEventId }) => ({ id: transitEventId }) }}
                />
            </Route>
            <Route
                element={<BreadcrumbedComponent />}
                handle={{
                    crumb: (data: any) => ({ pathnamePostFix: 'ev', name: 'Events', ...data }),
                }}
            >
                <Route path="ev" element={<EvEventsList />} />
                <Route
                    path="ev/new"
                    element={<EvEventEdit />}
                    loader={({ params }) => params}
                    handle={{ crumb: ({ evEventId }) => ({ id: evEventId }) }}
                />
                <Route
                    path="ev/:evEventId/edit"
                    element={<EvEventEdit />}
                    loader={({ params }) => params}
                    handle={{ crumb: ({ evEventId }) => ({ id: evEventId }) }}
                />
            </Route>
            <Route
                element={<BreadcrumbedComponent />}
                handle={{
                    crumb: (data: any) => ({
                        pathnamePostFix: 'emission',
                        name: 'Events',
                        ...data,
                    }),
                }}
            >
                <Route path="emission" element={<EmissionsEventsList />} />
                <Route
                    path="emission/new"
                    element={<EmissionEventEdit />}
                    loader={({ params }) => params}
                    handle={{ crumb: ({ emissionEventId }) => ({ id: emissionEventId }) }}
                />
                <Route
                    path="emission/:emissionEventId/edit"
                    element={<EmissionEventEdit />}
                    loader={({ params }) => params}
                    handle={{ crumb: ({ emissionEventId }) => ({ id: emissionEventId }) }}
                />
            </Route>
            <Route
                path="layers"
                element={
                    <LayersListWrapper>
                        <LayersTimeSelectors />
                    </LayersListWrapper>
                }
            />
        </Route>
    );
};
